import { ArchiveFileGroupUnitSearchRequest } from './archive-file-group-unit-search-request.model';
import { ArchiveFileStatusStatsInfo } from './archive-file-status-stats-info.model';
import { ArchiveFileGroupStatus } from './archive-file-group-status.enum';
export class ArchiveFileGroupSearchRequest extends ArchiveFileGroupUnitSearchRequest {
  filePageCount?: number;
  signFilePageCount?: number;
  printedFilePageCount?: number;
  fileCount?: number;
  signFileCount?: number;
  printedFileCount?: number;
  signFileRate?: number;
  fileSize?: number;
  signFileSize?: number;
  printedFileSize?: number;
  fileAttachPageCount?: number;
  signFileAttachPageCount?: number;
  printedFileAttachPageCount?: number;
  fileAttachCount?: number;
  signFileAttachCount?: number;
  printedFileAttachCount?: number;
  signFileAttachRate?: number;
  fileAttachSize?: number;
  signFileAttachSize?: number;
  printedFileAttachSize?: number;
  notArchivingFileCount?: number;
  notArchivingFilePageCount?: number;
  notArchivingFileSize?: number;
  notArchivingFileAttachCount?: number;
  notArchivingFileAttachPageCount?: number;
  notArchivingFileAttachSize?: number;
  catalogId?: number;
  volumeId?: number;
  volumeIds?: Array<number>;
  fileStatusStatistics?: Array<ArchiveFileStatusStatsInfo>;
  status?: ArchiveFileGroupStatus;
  comment?: string;

  volumeSortOrder?: number;
}
